import p from "./ghl-ui.es1539.js";
import f from "./ghl-ui.es1540.js";
import o from "./ghl-ui.es1536.js";
import u from "./ghl-ui.es1537.js";
import c from "./ghl-ui.es1538.js";
import n from "./ghl-ui.es1541.js";
import { Parser as l } from "./ghl-ui.es1620.js";
import { parseAnyDigitsSigned as h } from "./ghl-ui.es1621.js";
var C = /* @__PURE__ */ function(m) {
  u(t, m);
  var s = c(t);
  function t() {
    var r;
    p(this, t);
    for (var i = arguments.length, a = new Array(i), e = 0; e < i; e++)
      a[e] = arguments[e];
    return r = s.call.apply(s, [this].concat(a)), n(o(r), "priority", 40), n(o(r), "incompatibleTokens", "*"), r;
  }
  return f(t, [{
    key: "parse",
    value: function(i) {
      return h(i);
    }
  }, {
    key: "set",
    value: function(i, a, e) {
      return [new Date(e * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), t;
}(l);
export {
  C as TimestampSecondsParser
};
